import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { Observable } from 'rxjs';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { UserSummary } from '~/models/administration/user';
import { LocationSummary } from '~/models/modules/location';
import { AccountsService } from '~/services/administration.ts/accounts';
import { FormatService } from '~/services/administration.ts/format';
import { AddressesService } from '~/services/modules/stocks/addresses';
import { DisposeToService } from '~/services/modules/stocks/dispose-to';
import { LocationsService } from '~/services/modules/stocks/locations';
import { SecurityService } from '~/services/security.service';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';

@Component({
    selector: 'app-dispose-to-location',
    templateUrl: './dispose-to-location.html',
    styleUrls: ['./dispose-to-location.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisposeToLocationComponent implements OnInit, OnDestroy {
    _currentUser: UserSummary;
    _kendoTabStripPosition = 'left';
    _datePickerFormat: string;
    _costFormat: string;
    _innerWidth: any;
    _hiddenWindow: any;
    _maximized: any;
    _accountColumnsMap: GridColumnMap[] = [];
    _imageColumnsMap: GridColumnMap[] = [];
    _selectedAccount = new FormControl();
    _theme: string;
    _isNew: boolean;
    _form: FormGroup;
    _addressForm: FormGroup;
    _active: boolean;
    _isAutoGeneratingNumber: boolean;
    _addresses: any[];
    _addressesFiltered: any[];
    _locations: any[];
    _locationsFiltered: any[];

    _sites: any[];
    _sitesFiltered: any[];
    _tabEnabled: boolean;
    _invalidForm: boolean;
    _model: LocationSummary;

    _SIActive: boolean = true;
    NbrOfDisposedItems: any;



    @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;

    constructor(
        private _accountsService: AccountsService,
        private _locationsService: LocationsService,
        private _disposeToService: DisposeToService,
        private _fb: FormBuilder,
        private _themeManager: ThemeManagerService,
        private _layoutManager: LayoutManagerService,
        private _layoutComponent: LayoutComponent,
        private _addressesService: AddressesService,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _securityService: SecurityService,
        private _formatService: FormatService,
        @Inject(PORTAL_DATA) public data: any
    ) {
        if (data) {
            this._model = data.model;
            this._isNew = data.isNew;
            this._active = true;
        }
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });
        this._layoutManager.applyOverly();

        this._currentUser = this._securityService.currentUser;

        this._disposeToService.getNbrOfDisposedItems(this._model.id).subscribe((x: any) => {
            this.NbrOfDisposedItems = x;
        });
    }

    _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
        return this._accountsService.getAccounts(params, model);
    }
    //#region  ngOnInit
    ngOnInit() {


        this._selectedAccount.valueChanges.subscribe((x) => {
            if (x) {
                this._accountsService.getSitesListByAccount(x.id)
                    .subscribe((data: any) => {
                        this._sites = data.filter((x: { name: string }) => x.name != 'All Sites');
                        this._sitesFiltered = this._sites;
                    });
            }
        });

        this._initForm();
        /** Format */
        this._datePickerFormat = this._formatService.dateFormat;
        this._costFormat = this._formatService.costFormatValue;

    }
    //#endregion

    _SITabClick() {
        this._SIActive = true;
    }

    _sitesSelectionChanged(model: any): void {

    }



    _handleSitesFilter(value: any) {
        this._sitesFiltered = this._sites.filter(
            (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    _loadAddressesDD() {
        return this._addressesService.getAddressesListing()
            .subscribe((data: any) => {
                this._addresses = data;
                this._addressesFiltered = data;
            });
    }

    _handleAddressesFilter(value: any) {
        this._addressesFiltered = this._addresses.filter(
            (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    _loadLocationsDD() {
        return this._locationsService.getLocationListing()
            .subscribe((data: any) => {
                this._locations = data;
                this._locationsFiltered = data;
            });
    }

    _handleLocationsFilter(value: any) {
        this._locationsFiltered = this._locations.filter(
            (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }

    ngOnDestroy() {
        this._layoutManager.removeOverlay();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this._innerWidth = window.innerWidth;
        if (this._innerWidth > 450) {
            this._hiddenWindow = 'hidden';
            this._maximized = 'maximized';
        } else {
            this._hiddenWindow = '';
            this._maximized = 'default';
        }
        let windowSize = window.innerWidth;

        if (windowSize <= 991) {
            this._kendoTabStripPosition = 'top';
        } else {
            this._kendoTabStripPosition = 'left';
        }
    }

    _onTabSelect(e: any) {
        this._mobileMenuToggle();
    }

    _mobileMenuToggle() {
        let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
        mobiletabstrip.classList.toggle('visibletab');
    }

    _onSave(e: any) {
        this.submit();
    }

    _onCancel() {
        this._closeForm();
    }

    _closeForm() {
        this._active = false;
        this._gridLayoutManagerService.setGridDataSubjects('disposeToLocations');
        this._layoutManager.setFromChanged('disposeToLocations');
        this._gridLayoutManagerService.toggleFinishSubject();
        this.ngOnDestroy();
    }

    private _initForm() {
        this._form = this._fb.group({
            code: [this._model ? this._model.code : null, Validators.required],
            description: [this._model ? this._model.description : null],
            address: [this._model ? this._model.address : null],
            site: [this._model ? this._model.site : null]
        });

        if (!this._isNew) {
            this._selectedAccount.setValue(this._model.account);
        }
    }

    private submit = () => {
        // if (!this._selectedAccount.value || !this._form.get('site').value) {
        //     this._layoutComponent.openPopup({
        //         title: 'Validation',
        //         message: 'Please choose the Site for the desired Account.',
        //         withoutConfirm: true
        //     });
        //     return;
        // } else
        if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this._invalidForm = false;
            const model = this._form.value;

            //model['siteId'] = model.site.id;
            // if (!this._isNew) {
            //     this._locationsService
            //         .updateLocation(this._model.id, model)
            //         
            //         .subscribe(() => {
            //             this._closeForm();
            //         });
            // } else {
            this._disposeToService
                .createDisposeToLocation(model)

                .subscribe((response: any) => {
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                    this._closeForm();
                });
            // }
        }
    }
}
